<template>
    <div class="price-container fashion">
        <no-disclosure
            v-if="!!info.nodisclosureDes || hidePrice"
            :des="
                hidePrice
                    ? $t('md-detail-info.nondisclosure')
                    : info.nodisclosureDes
            "
        ></no-disclosure>
        <div class="price-value" v-else-if="info.listingStatus != 'Sold'">
            {{ $ft.formatCurrency({ value: info.price, noSpace:true, currencySymbol }) }}
        </div>
        <div v-else class="sold-price">
            {{
                $ft.formatCurrency({
                    value: showSoldPrice ? info.soldPrice : info.price,
                    noSpace: true,
                    currencySymbol
                })
            }}
        </div>
        <div
            class="origin-price"
            v-if="
                info.listingStatus == 'Sold' &&
                    showListingPrice &&
                    showSoldPrice &&
                    info.nodisclosureDes == null
            "
        >
            <span class="deprecated">{{
                $ft.formatCurrency({ value: info.price, noSpace: true, currencySymbol})
            }}</span>
            <span
                class="trend"
                v-if="trend !== '0.0%'"
                :class="{
                    up: info.soldPrice > info.price,
                    down: info.soldPrice < info.price
                }"
            >
                <span class="iconfont icon-expand"></span>
                {{ trend }}
            </span>
        </div>
    </div>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { usePageStore } from '@/store';
import noDisclosure from '../../../../components/nodisclosure';

export default {
    i18next: {
        ns: 'md-detail-info'
    },
    data: function() {
        return {};
    },
    components: { noDisclosure },
    computed: {
        ...rootMapState(usePageStore, {
            "house": store => store.page?.house || {},
            "currencySymbol": store => store.currency?.symbol
        }),
        ...mapState({
            "info": store => store.listingDetail.info || {}
        }),
        trend() {
            if (this.info.price) {
                return (
                    (
                        (Math.abs(this.info.soldPrice - this.info.price) /
                            this.info.price) *
                        100
                    ).toFixed(1) + '%'
                );
            } else {
                return '0.0%';
            }
        },
        showSoldPrice() {
            return (
                this.house.showSoldPrice && this.info.listingStatus == 'Sold'
            );
        },
        showListingPrice() {
            return (
                this.house.showListingPrice && this.info.listingStatus == 'Sold'
            );
        },
        hidePrice() {
            return (
                !this.house.showListingPrice &&
                !this.house.showSoldPrice &&
                this.info.listingStatus == 'Sold'
            );
        }
    }
};
</script>

<style lang="scss">
@import '../../../../theme/mixin.scss';
@import '../../../../theme/media.scss';
.price-container.fashion {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    position: relative;
    .sold-price {
        font-size: 30px;
        color: #8b93a7;
        font-family: var(--font-bold);
        &.mark {
            line-height: 20px;
        }
    }
    .nodisclosure {
        .dollar {
            @include color-theme();
            font-size: 24px;
        }
        .secret {
            font-size: 12px;
            @include color-theme();
        }
        .des {
            font-size: 12px;
            color: #ff5661;
        }
    }
    .price-value {
        @include color-theme();
        font-size: 30px;
        font-family: var(--font-title);
    }
    .origin-price {
        font-size: 14px;
        color: #8b93a7;
        line-height: 16px;
        margin-top: 10px;
        .deprecated {
            text-decoration: line-through;
            margin: 0 10px;
        }
        .trend {
            font-family: var(--font-bold);
            &.down {
                color: #ff5661;
            }
            &.up {
                @include color-theme();
                .iconfont {
                    transform: rotate(180deg);
                }
            }
            .iconfont {
                display: inline-block;
            }
        }
    }
}
@media (max-width: 600px) {
    .price-container.fashion {
        .sold-price {
            font-size: 22px;
            color: #8b93a7;
            font-family: var(--font-title);
            &.mark {
                line-height: 20px;
            }
        }
        .price-value {
            @include color-theme();
            font-size: 22px;
            font-family: var(--font-title);
        }
        .origin-price {
            margin-top: 8px;
            .deprecated {
            }
            .trend {
                &.down {
                }
                &.up {
                    .iconfont {
                    }
                }
                .iconfont {
                }
            }
        }
    }
}
</style>
